import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { WipperozGeolocationService } from 'app/wipperoz-core/services/location.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() showGoogle = false;
  year = new Date().getFullYear();

  helpLink = $localize`:@@helpIntercomLink:https://help.wipperoz.com/en`;
  googlePrivacyPolicyLink = $localize`:@@googlePrivacyPolicyLink:https://policies.google.com/privacy?hl=en`;
  googleTermsConditionsLink = $localize`:@@googleTermsConditionsLink:https://policies.google.com/terms?hl=en`;
  faqRoute = '/about/faq';
  aboutContactRoute = '/about/contact';
  aboutTermsRoute = '/about/terms';
  aboutPrivacyRoute = '/about/privacy';
  pricingRoute = '/pricing';
  pressRoute = '/press';
  blogRoute = '/blog';
  aboutRoute = '/about';

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private locationService: WipperozGeolocationService) {}

  ngOnInit(): void {}

  onLanguageClick(language: string): void {
    if (isPlatformBrowser(this.platformId)) {
      const pathname = window.location.pathname.split('/');
      const url = [];
      for (let index = 2; index < pathname.length; index++) {
        url.push(pathname[index]);
      }
      const a = `${url.join('/')}`;
      this.locationService.changeLocale(language, `/${url.join('/')}`);
    }
  }
}
